export default __webpack_public_path__ + "static/media/thumbnail.e3abc60c.png";